/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesAdditionalInputComponent} from './part-number-changes-additional-input.component';
import {PncAddAdditionInputButtonComponent} from './pnc-add-addition-input-button/pnc-add-addition-input-button.component';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [PartNumberChangesAdditionalInputComponent, PncAddAdditionInputButtonComponent],
    exports: [
        PartNumberChangesAdditionalInputComponent,
        PncAddAdditionInputButtonComponent
    ],
    imports: [CommonModule, TooltipModule]
})
export class PartNumberChangesAdditionalInputModule {
}
